import { STATIC_HOST } from "lib/constants";

export const staticURL = (filePath: string) => `${STATIC_HOST}/${filePath}`;
